import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { ErrorScreenType } from './error-screen.types';
import { ERROR_SCREEN_CONFIGS } from './error-screen.config';

@Component({
  selector: 'k-error-screen',
  templateUrl: './error-screen.component.html',
  imports: [ TranslateModule, ButtonComponent ],
})
export class ErrorScreenComponent {
  private router = inject(Router);

  type = input.required<ErrorScreenType>();
  customTitle = input<string>();
  customMessage = input<string>();

  config = computed(() => ERROR_SCREEN_CONFIGS[this.type()]);

  onAction(): void {
    const cfg = this.config();
    if (cfg.isReload) {
      window.location.reload();
    } else if (cfg.actionRoute) {
      this.router.navigate([ cfg.actionRoute ]);
    }
  }
}
